import React from 'react';
import { transformHTML } from './action-text-attachment';
import './styles.css';

const ContentHTML = ({ element }) => {
  return (
    <div className="content-html-container">
      {element?.content ? (
        <div style={{ width: '100%' }}>
          <div
            className="content-resource-element"
            dangerouslySetInnerHTML={{
              __html: transformHTML(element?.content),
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ContentHTML;
